import React from 'react';
import PropTypes from 'prop-types';
import BaseNext from '../base-next';

const Zip = props => {
  const {
    onChange,
    value,
    error,
    touched,
    onBlur,
    id,
    isDisabled,
    setZipAutocompleteState,
    isCosigner,
    hideErrorMessage
  } = props;
  return (
    <BaseNext
      isDisabled={isDisabled}
      data-cv-test="addressZip"
      onChange={e => {
        setZipAutocompleteState('manual');
        onChange(e);
      }}
      onBlur={onBlur}
      value={value}
      touched={touched}
      error={error}
      id={id}
      type="numeric"
      labelText="Zip Code"
      maxLength={5}
      isCosigner={isCosigner}
      hideErrorMessage={hideErrorMessage}
    />
  );
};

Zip.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  touched: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string,
  setZipAutocompleteState: PropTypes.func,
  isCosigner: PropTypes.bool
};

Zip.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  value: '',
  touched: false,
  error: false,
  isDisabled: false,
  id: '',
  setZipAutocompleteState: () => {},
  isCosigner: false
};

export default Zip;
